import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Sharing } from '../../../../../../pages/project/settings/Sharing';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/sharing')({
  component: SharingRoute,
});

function SharingRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <Sharing projectId={project_id} portalApiClient={apiClient} />;
}
